import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button, Input } from '../../../components/UI'
import ErrorMessageWithExclamation from '../../../components/UI/ErrorMessageWithExclamation'
import ForgotPasswordEmail from './ForgotPasswordEmail'

import {
  selectErrorSendResetPasswordEmail,
  selectLoadingSendResetPasswordEmail,
} from '../../../routing/fetchingfunction/user/user.reducer'
import { sendResetPasswordEmail } from '../../../routing/fetchingfunction/user/user.action'

import { ForgotPasswordScheme } from '../../../routing/utils/validators'

const ForgotPassword = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(selectLoadingSendResetPasswordEmail)
  const error = useSelector(selectErrorSendResetPasswordEmail)

  const methods = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(ForgotPasswordScheme),
  })

  const {
    formState: { errors },
    reset,
    handleSubmit,
    register,
  } = methods

  const [isEmailSent, setIsEmailSent] = useState(false)

  const onSubmit = (data) => {
    dispatch(sendResetPasswordEmail(data))
      .unwrap()
      .then((response) => {
        console.log(response)
        setIsEmailSent(true)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <div
      className={`${isEmailSent ? 'max-w-[800px] w-full px-[148px] mx-auto my-16 flex flex-col items-center justify-start' : 'bg-[#FEEBDD] rounded-lg text-primary-100 max-w-[800px] w-full px-[148px] py-16 mx-auto my-16 flex flex-col items-center justify-start'}`}
    >
      {isEmailSent ? (
        <ForgotPasswordEmail />
      ) : (
        <>
          <img
            src="/assets/image/apoloLogoImg.svg"
            alt="Logo"
            width={180}
            height={48}
            className="mb-[24px]"
          />

          <h2 className="text-sm font-medium text-center mb-[20px]">
            Enter the email address associated with your account and
            <br />
            we’ll send you a reset link.
          </h2>

          {typeof error === 'string' && (
            <ErrorMessageWithExclamation text={error} className="mr-auto mb-4" />
          )}

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full">
              <div>
                <label className="text-sm font-medium mb-[6px]" htmlFor="email">
                  Email
                </label>

                <Input
                  id="email"
                  wrapperClassName="w-full"
                  placeholder="Enter your registered email"
                  type="text"
                  inputMode="email"
                  {...register('email')}
                />

                {errors.email && <ErrorMessageWithExclamation text={errors.email.message} />}
              </div>

              <Button
                className="mt-[24px] w-full h-[44px] font-semibold text-base"
                type="submit"
                isLoading={isLoading}
              >
                Submit
              </Button>

              <div className="text-center mt-[24px]">
                <p className="text-primary-100 text-sm inline-block bg-transparent font-normal">
                  Already remembered your password?{' '}
                  <Link
                    to="/login"
                    className="font-semibold hover:text-primary-100 hover:underline"
                  >
                    Login here
                  </Link>
                </p>
              </div>
            </form>
          </FormProvider>
        </>
      )}
    </div>
  )
}

export default ForgotPassword
